var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{directives:[{name:"t",rawName:"v-t",value:("zero_products"),expression:"\"zero_products\""}],staticClass:"h4 no-products-text"})}
var staticRenderFns = []

export { render, staticRenderFns }